import React from "react";
import PropTypes from "prop-types";
import * as R from "ramda";

import Icon from "components/Icon";
import { getFullAddress } from "utils/address";
import { formatFullAddress } from "utils/format";
import { getAddress } from "utils/location";
import { eventLocationPropType } from "utils/sharedPropTypes";

import styles from "./EventLocationsFieldLegacy.scss";
import UnansweredField from "./UnansweredField";

export const EventLocationsField = <h3>Legacy unsuported field</h3>;

const formatLocation = R.pipe(getAddress, getFullAddress, formatFullAddress);

export const Disabled = ({ value = [] }) => (
  <div className={styles.container}>
    {R.isEmpty(value) && <UnansweredField />}
    {R.map(
      (location) => (
        <div key={`location-${formatLocation(location)}`} className={styles.locationContainer}>
          <div className={styles.icon}>
            <Icon size="lg" icon="map-marker-alt" />
          </div>
          {formatLocation(location)}
        </div>
      ),
      value,
    )}
  </div>
);
Disabled.propTypes = {
  value: PropTypes.arrayOf(eventLocationPropType),
};

export const Issued = ({ value = [] }) => {
  if (R.isEmpty(value)) {
    return (
      <div className={styles.container}>
        <UnansweredField />
      </div>
    );
  }

  const location = R.head(value);

  return (
    <div className={styles.issued}>
      <div className={styles.locationContainer}>
        <div className={styles.icon}>
          <Icon size="lg" icon="map-marker-alt" />
        </div>
        {formatLocation(location)}
      </div>
      {R.length(value) > 1 && (
        <div className={styles.locationContainer}>
          <div className={styles.icon}>
            <Icon size="lg" icon="map-marker-alt" />
          </div>
          {R.length(value) - 1} other locations
        </div>
      )}
    </div>
  );
};
Issued.propTypes = {
  value: PropTypes.arrayOf(eventLocationPropType),
};

export default EventLocationsField;
